<h1 i18n="@@contacts" >
        Contacts
</h1>
<section id="contact" *ngIf="pageData" class="contact pt-4">


        <div  *ngIf="pageData.attributes.URLforMap" class="position-relative" style="height: 270px;">
                <div style="width: 100%"><iframe width="100%"
                                (load)="isFrameLoading=false" [class.d-none]="isFrameLoading" height="270"
                                frameborder="0" scrolling="no" marginheight="0" marginwidth="0"
                                [src]="urlSafeMapUrl"></iframe><a href="https://www.maps.ie/route-planner.htm"></a>
                </div>
                <div *ngIf="isFrameLoading" [@enterAnimation] id="loader"></div>
        </div>

        <div class="row mt-5 pb-5 color-gray">
                <div class="col-6">
                        <h4>{{pageData.attributes.CompanyTitle}}</h4>
                </div>
                <div class="col-6 text-right">
                        <h4 i18n="@@questions">Do you have questions?</h4>
                </div>

        </div>
        <div class="row">

                <div class="col-lg-4">
                        <div class="info">
                                <div class="address">
                                        <i class="icofont-google-map"></i>
                                        <h4 i18n="@@location">Location:</h4>
                                        <p>{{pageData.attributes.Location}}</p>
                                </div>

                                <div class="email">
                                        <i class="icofont-envelope"></i>
                                        <h4>Email:</h4>
                                        <p>{{pageData.attributes.Email}}</p>
                                </div>

                                <div class="phone">
                                        <i class="icofont-phone"></i>
                                        <h4 i18n="@@call">Call:</h4>
                                        <p>{{pageData.attributes.Phone}}</p>
                                </div>

                        </div>

                </div>

                <div class="col-lg-8 mt-5 mt-lg-0">

                        <form role="form" (ngSubmit)="sendMessage(); form.reset()" #form="ngForm"
                                class="php-email-form">
                                <div class="form-row">
                                        <div class="col-md-6 form-group">
                                                <input type="text" name="name" #name="ngModel" required
                                                        class="form-control" id="name" placeholder="Your Name" i18n-placeholder="@@your-name"
                                                        [(ngModel)]="authorName" data-rule="minlen:4"
                                                        data-msg="Please enter at least 4 chars">
                                                <div [hidden]="name.valid || name.untouched"
                                                        class="alert p-1 my-1 alert-danger" i18n="@@required">
                                                        Required
                                                </div>
                                        </div>
                                        <div class="col-md-6 form-group">
                                                <input type="email" class="form-control" [(ngModel)]="dataMail.from"
                                                        #email="ngModel" required email name="email" id="email"
                                                        placeholder="Your Email" i18n-placeholder="@@your-email" data-rule="email"
                                                        data-msg="Please enter a valid email">
                                                <div [hidden]="email.valid || email.untouched"
                                                        class="alert p-1 my-1 alert-danger" i18n="@@required">
                                                        Required
                                                </div>
                                        </div>
                                </div>
                                <div class="form-group">
                                        <input type="text" [(ngModel)]="dataMail.subject" required class="form-control"
                                                #subject="ngModel" name="subject" id="subject" placeholder="Subject" i18n-placeholder="@@your-subject"
                                                data-rule="minlen:4"
                                                data-msg="Please enter at least 8 chars of subject">
                                        <div [hidden]="subject.valid || subject.untouched"
                                                class="alert p-1 my-1 alert-danger" i18n="@@required">
                                                Required
                                        </div>
                                </div>
                                <div class="form-group">
                                        <textarea class="form-control" [(ngModel)]="dataMail.text" required
                                                name="message" #message="ngModel" rows="5" data-rule="required"
                                                data-msg="Please write something for us"
                                                placeholder="Message" i18n-placeholder="@@your-message"></textarea>
                                        <div [hidden]="message.valid || message.untouched"
                                                class="alert p-1 my-1 alert-danger" i18n="@@required">
                                                Required
                                        </div>
                                </div>
                                <div *ngIf="pageData.attributes.CaptchaSiteKey">
                                        <re-captcha (resolved)="resolved($event)"
                                                siteKey="{{pageData.attributes.CaptchaSiteKey}}"></re-captcha>
                                </div>
                                <div class="my-3">
                                        <div class="alert p-1 my-1 alert-warning" *ngIf="loading">Loading</div>
                                        <div class="alert p-1 my-1 alert-danger" i18n="@@error-message" *ngIf="isError">Error, please call us
                                        </div>
                                        <div class="alert p-1 my-1 alert-success" i18n="@@sended-message" *ngIf="messageSended">Your message has
                                                been sent. Thank you!</div>
                                </div>
                                <div class="text-center">
                                        <button type="submit"
                                                [disabled]="name.invalid || email.invalid || subject.invalid || message.invalid || !captha"
                                                class="btn btn-outline-danger" i18n="@@button-message">Send Message</button>

                                </div>
                        </form>

                </div>

        </div>

</section>